import React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import MailIcon from '@material-ui/icons/Mail';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import SubjectIcon from '@material-ui/icons/Subject';
import renderHtml from '../../../lib/transformHtml';
import clsx from 'clsx';
//import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import UpdateIcon from '@material-ui/icons/Update';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { readable } from '../../../lib/dateFunctions';
import Chip from '@material-ui/core/Chip';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 1),
    width: '100%',
    borderRadius: '14px',
    backgroundColor: '#fffcdd',
  },
  alignRight: {
    marginLeft: '20%',
    [theme.breakpoints.down('md')]: {
      marginLeft: '2%',
    },
    backgroundColor: '#efefef',
  },
  inline: {
    display: 'inline-flex',
    marginRight: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(1, 2),
    backgroundColor: '#ffffff',
  },
  noPad: {
    padding: '0px!important',
  },
  alignMiddle: {
    display: 'flex',
    '& > b': {
      display: 'flex',
      '& > svg': {
        margin: theme.spacing(0, 2, 0, 0),
      },
      [theme.breakpoints.up('sm')]: {
        marginRight: theme.spacing(2),
      },
    },
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      fontSize: '90%',
    },
    justifyContent: 'flex-start',
    maxHeight: '4em',
    overflow: 'auto',
  },
  alignEnd: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& > b': {
      margin: theme.spacing(0, 2, 0, 1),
    },
    flexShrink: 1,
  },
  flexRight: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'end',
    flexDirection: 'column',
    '&>p': {
      '&>svg': {
        marginRight: '1em',
      },
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
    },
  },
  expanded: {
    transform: 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeOut,
    }),
  },
  center: {
    height: 'auto',
    left: '49%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  header: {
    paddingBottom: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '&>div:last-child': {
      margin: '8px 0px 0px auto',
      flexDirection: 'column',
      display: 'flex',
    },
  },
  chip: {
    fontSize: '110%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.up('md')]: {
      minWidth: theme.spacing(10),
      minHeight: theme.spacing(10),
      '&>svg': {
        minWidth: theme.spacing(8),
        minHeight: theme.spacing(8),
      },
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class Mail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: !!props.overwriteOpen ? true : false };
  }

  handleCollapse = () => {
    this.setState({ open: !this.state.open });
  };

  componentDidMount() {}

  render() {
    const { classes } = this.props;
    return (
      <Card
        raised={true}
        variant='outlined'
        className={clsx(classes.root, {
          [classes.alignRight]: this.props.align,
        })}
      >
        <CardHeader
          className={classes.header}
          disableTypography={true}
          avatar={
            <Avatar
              className={classes.avatar}
              alt={
                !!this.props.item.creator
                  ? this.props.item.creator?.firstname + ' ' + this.props.item.creator?.lastname
                  : 'Mail'
              }
              src={
                process.env.REACT_APP_API_URL +
                '/avatar/' +
                this.props.item.creator?.uuid +
                '?thumb'
              }
            >
              {' '}
              <MailIcon />{' '}
            </Avatar>
          }
          title={
            <>
              <Typography className={classes.alignMiddle} variant='subtitle1' gutterBottom>
                <b>
                  <ContactMailIcon /> Von:
                </b>
                <Chip
                  className={classes.chip}
                  label={
                    this.props.item.data?.from?.length > 0
                      ? this.props.item.data?.from[0].personal +
                        ' <' +
                        this.props.item.data?.from[0].mail +
                        '>'
                      : ''
                  }
                />
              </Typography>
              {this.props.item.data?.cc?.length >= 1 && (
                <Typography className={classes.alignMiddle} variant='subtitle1' gutterBottom>
                  <SupervisorAccountIcon />
                  <b>CC:</b>
                  {this.props.item.data.cc?.map((item, index) => {
                    return (
                      <Chip
                        className={classes.chip}
                        label={`<${item.personal || item.email || item.mail}>`}
                      />
                    );
                  })}
                </Typography>
              )}

              {this.props.item.data?.bcc?.length >= 1 && (
                <Typography className={classes.alignMiddle} variant='subtitle1' gutterBottom>
                  <b>
                    <SupervisorAccountIcon />
                    BCC:
                  </b>
                  {this.props.item.data.bcc?.map((item, index) => {
                    return (
                      <Chip
                        className={classes.chip}
                        label={`<${item.personal || item.email || item.mail}>`}
                      />
                    );
                  })}
                </Typography>
              )}

              {this.props.item.data?.to?.length >= 1 && (
                <Typography className={classes.alignMiddle} variant='subtitle1' gutterBottom>
                  <b>
                    <SupervisorAccountIcon /> An:
                  </b>
                  {this.props.item.data.to.map((item, index) => {
                    return (
                      <Chip
                        key={index}
                        className={classes.chip}
                        label={`${item.personal || item.email || item.mail}`}
                      />
                    );
                  })}
                </Typography>
              )}
            </>
          }
          subheader={
            <>
              {this.props.item.data?.subject && (
                <Typography
                  className={classes.alignMiddle}
                  variant='h5'
                  color='textPrimary'
                  component='p'
                >
                  <b>
                    <SubjectIcon /> Betreff:
                  </b>
                  {this.props.item.data?.subject}
                </Typography>
              )}
              {!!this.props.item.data?.files?.text && (
                <Typography
                  className={classes.alignMiddle}
                  variant='h6'
                  color='textPrimary'
                  component='p'
                >
                  <b>
                    <AttachFileIcon /> Anhang:
                  </b>
                  {this.props.item.data?.files?.text}
                </Typography>
              )}
            </>
          }
          action={
            <div className={classes.flexRight}>
              <Typography variant='overline' align='right' component='p'>
                <UpdateIcon fontSize='small' /> {readable(this.props.item.created_at)}
              </Typography>

              <Button
                onClick={() =>
                  this.props.respondFunction(this.props.item.data, this.props.item.data?.from)
                }
                startIcon={<LabelImportantIcon />}
                variant='contained'
                color='primary'
              >
                {' '}
                Jetzt Antworten{' '}
              </Button>
            </div>
          }
        />

        <CardContent className={classes.paper}>
          {renderHtml(this.props.item.data?.body, this.state.open, this.handleCollapse)}
          <IconButton onClick={this.handleCollapse} color='primary' className={classes.center}>
            <KeyboardArrowDownIcon
              className={this.state.open ? classes.expanded : classes.closed}
            />
          </IconButton>
        </CardContent>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({ Authentication: state.Authentication });

const mapDispatchToProps = (dispatch) => ({ dispatch, push });

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(Mail);
